import { render, staticRenderFns } from "./ClearPlayer.vue?vue&type=template&id=1b117a03&"
import script from "./ClearPlayer.vue?vue&type=script&lang=js&"
export * from "./ClearPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports